module.exports = __webpack_public_path__ + "static/icon_nutzung-99916b46acd0427cbd104f73a9b397c4.png";